import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Button,
  Stack,
  Text,
} from "@chakra-ui/react";
import { ReactNode } from "react";
import { ErrorBoundary as ErrBound, FallbackProps } from "react-error-boundary";

export default function ErrorBoundary({ children }: { children: ReactNode }) {
  return <ErrBound FallbackComponent={ErrorFallback}>{children}</ErrBound>;
}

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const errMsg = (error as Error)?.message;

  return (
    <Stack
      height={"100vh"}
      alignItems={"center"}
      justifyContent={"center"}
      spacing={8}
      p={4}
    >
      <Stack spacing={6}>
        <Text fontSize="4xl" fontWeight={"bold"} textAlign={"center"}>
          {process.env.REACT_APP_NAME}
        </Text>
        <Alert status="error" variant="left-accent" alignItems={"start"}>
          <AlertIcon />
          <Stack maxW={"600px"}>
            <AlertTitle>
              We caught an error {errMsg ? ` - [ ${errMsg} ]` : ""}
            </AlertTitle>
            <AlertDescription>
              Something went wrong. Please reload the page and try again. If the
              problem persists, please contact the administrator.
            </AlertDescription>
          </Stack>
        </Alert>
        <Button onClick={() => window.location.reload()}>Reload</Button>
      </Stack>
    </Stack>
  );
}
